(function ($) {
    'use strict';

    // For currency fields, this can be used in place of val() to get the normalized decimal value of the currency
    // i.e. - For an input with a value of "$5,000.00", this will return "5000.00"
    function normalizedCurrencyVal() {

        return getNormalizedCurrencyValue($(this).val());
    }

    //
    // Strips all currency formatting for a given value
    //
    function getNormalizedCurrencyValue(value) {

        // first determine if we are working with a negative number by the presence
        // of parens around the value
        var isNegative = false
        var negativeCurrencyRegex = new RegExp(/^\s*\((.*)\)$/);

        var match = negativeCurrencyRegex.exec(value);
        if (match) {
            // get the value minus the parens
            isNegative = true;
            value = match[1];
        }
        else {
            // handle format -$####
            var negativeNumberRegex = new RegExp(/^\s*-\s*(.*)/);
            match = negativeNumberRegex.exec(value);
            if (match) {
                isNegative = true;
                value = match[1];
            }
        }

        // strip out the leading dollar sign and any commas
        value = value.replace(/^[\s$]+/, '').replace(/,/g, '');

        // finally negate the base number if we encountered negative number annotation
        return (isNegative ? '-' : '') + value;
    }

    // For percent fields, this can be used in place of val() to get the normalized decimal value of the percent
    // i.e. - For an input with a value of "100%", this will return "100"
    function normalizedPercentVal() {

        return getNormalizedPercentValue($(this).val());
    }

    //
    // Strips all percent formatting for a given value
    //
    function getNormalizedPercentValue(value) {

        return value.replace(/[\s%,]/g, '');
    }

    // For SSN, TIN, and FEIN fields, this can be used in place of val() to get the normalized string value of the ID
    // i.e. - For an input with a value of "123-45-6789", this will return "123456789"
    function normalizedIDVal() {

        return getNormalizedIDValue($(this).val());
    }

    //
    // Strips all SSN, TIN and FEIN formatting for a given value
    //
    function getNormalizedIDValue(value) {

        return value.replace(/-/g, '');
    }

    // For decmial fields, this can be used in place of val() to get the normalized value of the decimal
    // i.e. - For an input with a value of "1,000.5", this will return "1000.5"
    function normalizedDecimalVal() {

        return getNormalizedDecimalValue($(this).val());
    }

    //
    // Strips all decimal formatting for a given value
    //
    function getNormalizedDecimalValue(value) {

        return value.replace(/[\s,]/g, '');
    }

    // For boolean fields, this can be used in place of val() to get the normalized value of the boolean
    // i.e. - For an input with a value of "True" (the way asp-for sends it), this will return "true"
    function normalizedBoolVal() {

        return getNormalizedBoolValue($(this).val());
    }

    //
    // Strips all boolean formatting for a given value
    //
    function getNormalizedBoolValue(value) {

        return value.toLowerCase() == "true";
    }

    jQuery.fn.extend({
        normalizedCurrencyVal,
        normalizedPercentVal,
        normalizedIDVal,
        normalizedDecimalVal,
        normalizedBoolVal
    });

    jQuery.extend({
        getNormalizedCurrencyValue,
        getNormalizedPercentValue,
        getNormalizedIDValue,
        getNormalizedDecimalValue,
        getNormalizedBoolValue
    });

})(jQuery);